import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

export const useLoadMore = (fetchNextPage: () => any, isFetching: boolean) => {
  const { ref: loader, inView } = useInView();

  useEffect(() => {
    if (inView && !isFetching) {
      fetchNextPage();
    }
  }, [inView, isFetching]);

  return loader;
};
